import { doc, updateDoc, arrayUnion, getFirestore } from 'firebase/firestore';
import Styles from './styles.module.css';
import React from 'react';
import { RxCross2 } from "react-icons/rx";
import { fetchJobPostingPdf, fetchJobPostingYearsForSchool } from "../../0.functions/jobPostingAsset";
import JobPostingImage from "../../0.functions/JobPostingImage";

type SchoolItemProps = {
  schoolId: string;
  recruitId: string;
  setToggle: React.Dispatch<React.SetStateAction<any>>;
};

const SchoolJobPostings: React.FC<SchoolItemProps> = ({ schoolId, recruitId, setToggle }) => {

  const db = getFirestore();

  const handleDownload = async () => {
    try {
      // この学校が送付先に入っている年度の求人票を優先して取得する
      const years = await fetchJobPostingYearsForSchool(recruitId, schoolId);
      const response = await fetchJobPostingPdf(recruitId, years, 20);
      if (!response.ok) {
        throw new Error("fetch failed");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "求人票.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);

      const ref = doc(db, "schools", schoolId);
      updateDoc(ref, {
        print_2027: arrayUnion(recruitId),
      });
    } catch (e) {
      console.error("handleDownload error:", e);
    }
  };


  return (
    <>
    <div className={Styles.modal}>
      <div className={Styles.background_black} onClick={() => setToggle({ type: "",  id: "", name: "" })}></div>
      <div className={Styles.contents}>
        <div className={Styles.modal_title}>
          <h4>求人票</h4>
          <RxCross2 className={Styles.modal_cross} onClick={() => setToggle({ type: "",  id: "", name: ""})} />
        </div>
        <div className={Styles.jobPostings}>
          {/* この学校が送付先に入っている年度の求人票を優先して表示する */}
          <JobPostingImage recruitId={recruitId} schoolId={schoolId} />
        </div>
        <div className={Styles.save}>
          <button className={Styles.postingsModal_bottom_cancel} onClick={() => setToggle({ type: "",  id: "", name: ""})}>閉じる</button>
          <button className={Styles.postingsModal_bottom_save} onClick={handleDownload}>印刷</button>
        </div>
      </div>
    </div>
    </>
  );
}

export default SchoolJobPostings;